import { PageHeader } from '@/components/layout/PageHeader';
import { getApiBaseUrl } from '@/config/env';

const SECRET_HEADER = 'x-social-webhook-token';

const SAMPLE_META = `{
  "object": "page",
  "entry": [{
    "messaging": [{
      "sender": { "id": "123" },
      "message": { "text": "Hi, I need pricing" }
    }]
  }]
}`;

export function SocialWebhooksPage({ embedded }: { embedded?: boolean } = {}) {
  const apiBase = getApiBaseUrl();

  return (
    <div className="space-y-6">
      {!embedded && (
        <PageHeader
          title="Social webhooks"
          description="Configure Meta, LinkedIn, and other networks to POST inbound events"
          breadcrumbs={[{ label: 'Social', to: '/social' }, { label: 'Webhooks' }]}
        />
      )}

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="card p-4 space-y-3">
          <h3 className="font-semibold text-sm">Inbound endpoints</h3>
          <p className="text-sm text-slate-600">
            Point your app webhook URL here. Meta uses GET verification with <code>hub.verify_token</code> matching
            your token in <a href="/social/setup" className="text-primary-600 hover:underline">Setup</a>.
            POST requests must include query param <code>socialAccountId</code> and header{' '}
            <code>{SECRET_HEADER}</code> when OAuth app secret is not configured.
          </p>
          <div className="rounded bg-slate-50 dark:bg-slate-900 p-3 text-xs font-mono break-all">
            GET/POST {apiBase}/v1/social/webhooks/facebook?socialAccountId={'{accountId}'}
          </div>
          <div className="rounded bg-slate-50 dark:bg-slate-900 p-3 text-xs font-mono break-all">
            POST {apiBase}/v1/social/webhooks/instagram?socialAccountId={'{accountId}'}
          </div>
          <div className="rounded bg-slate-50 dark:bg-slate-900 p-3 text-xs font-mono break-all">
            POST {apiBase}/v1/social/webhooks/linkedin?socialAccountId={'{accountId}'}
          </div>
          <div className="rounded bg-slate-50 dark:bg-slate-900 p-3 text-xs font-mono break-all">
            POST {apiBase}/v1/social/webhooks/twitter?socialAccountId={'{accountId}'}
          </div>
        </div>

        <div className="card p-4">
          <h3 className="font-semibold text-sm mb-2">Sample Meta payload</h3>
          <pre className="text-xs bg-slate-50 dark:bg-slate-900 p-3 rounded overflow-x-auto">{SAMPLE_META}</pre>
        </div>
      </div>

      <div className="card p-4 text-sm text-slate-600">
        <p>
          Inbound messages flow through <code>WebhookDispatcher</code> → <code>SocialInboxService</code> with{' '}
          <code>SocialSentimentService</code> scoring. CRM leads are created via <code>LeadIntakeService</code> on
          qualifying conversations.
        </p>
      </div>
    </div>
  );
}
